export default __webpack_public_path__ + "static/media/190615-jessica-biel-al-1016.87ea8c57.jpg";